import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Iframe extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { width, height, url } = content;

        return url ? (
            <iframe scrolling="no" frameBorder="0" width={`${width}px`} height={`${height}px`} border="0" src={url} />
        ) : null;
    }
}

export default errorBoundary(Iframe);
